module.exports = __webpack_public_path__ + "img/icon-smart-office.8083ba01.svg";